import React from 'react';
import { FlatList, Image } from 'react-native';
import { Icons } from '../../Components';
import { ProfileHelpers } from '../api';
import type { CodeRequestProps, MyPlayerProps, PlayerReferralProps, PromoProps, PublicPlayerProps } from '../../types';
import { Text, View, Button } from '../../Components/Themed';
import { useColors } from '../../constants/useColors';


type ProfileWelcomeProps = {
    player:MyPlayerProps,
    width:number,
    onStartSetup: () => void,
    code_details: {
        code_request?:CodeRequestProps,
        referrer?:PublicPlayerProps,
        promo?:PromoProps,
        player_referral?:PlayerReferralProps
    }
    onClose:() => void
}

const sections = ['welcome', 'code']
const ProfileWelcome = ({ width, player, code_details, onStartSetup, onClose }:ProfileWelcomeProps) => {
    const C = useColors();
    const { code_request, promo, referrer } = code_details;
    const MAX_WIDTH = 500
    const size = width > MAX_WIDTH ? MAX_WIDTH : width
    const renderSections = (data:{ item:string, index:number }) => {
        switch(data.item){
            case 'welcome':
                return (
                    <Image
                        source={{ uri: 'https://res.cloudinary.com/hoabts6mc/image/upload/v1714506366/Welcome_James_pfzn7z.webp' }}
                        style={{ width:size, height:size, alignSelf:'center' }}
                        resizeMode='cover'
                    />
                )
            case 'code':
                if(!code_request) { return <></> }
                if(!promo){ return <></> }
                if(['closed','fulfilled'].includes(code_request.status)){  return <></> }
                return (
                <View float style={{ margin:15, flexDirection:'row' }}>
                    <View transparent style={{ padding:10, justifyContent:'center' }}>
                        <Icons.GiftIcon size={40} color={C.text.gold} />
                    </View>
                    <View transparent style={{flex:1, padding:10 }}>
                        <Text theme='h1'>@{referrer?.username} has a gift for you</Text>
                        <Text style={{ paddingTop:5 }} theme='h2'>{ProfileHelpers.getReferralDescription(promo)}</Text>
                    </View>
                </View>
                )
            default:return <></>
        }
    }
    return (
        <View style={{ flex:1 }}>
            <View style={{ padding:20 }}>
                <Text size={26} theme='h2'>Welcome @{player.username}!</Text>
                <Text style={{ marginTop:15 }} size={14} theme='h2'>We are so glad that you found us! Use the setup wizard to complete your account setup.</Text>
            </View>
            <View style={{ flex:1 }}>
                <FlatList
                    data={sections}
                    key={'welcome_sections'}
                    keyExtractor={item => item}
                    renderItem={renderSections}
                />
            </View>
            <View style={{ flexDirection:'row', padding:10 }}>
                <Button
                    title={`DO IT LATER`}
                    style={{ flex:3, marginRight:5 }}
                    type='close'
                    onPress={() => onClose()}
                />
                <Button
                    title='SET UP MY ACCOUNT'
                    style={{ flex:5 }}
                    type='success'
                    onPress={() => onStartSetup()}
                />
            </View>
        </View>
    )
}

export default ProfileWelcome